module.exports = __webpack_public_path__ + "img/student.5f1c450d.png";